import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Col, Button } from 'react-bootstrap';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import moment from 'moment';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


function CmsElementCommerceOnlineAppointmentBooking(props) {
  const { editMode, index, showElementSettings } = props;

  const intl = useIntl();
  const messages = intl?.messages || {};

  // CMS Logic Hook
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // Local State
  const [addressInputFocused, setAddressInputFocused] = useState(false);

  useEffect(() => {
    if (intl?.locale) {
      moment.locale(intl.locale);
    }
  }, [intl?.locale]);


  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  const isVisible = editMode || shown;
  const shownClass = isVisible ? 'elem-shown' : 'elem-hidden';
  const textClass = `text-${getParamValue('mainColor', 'master')}`;
  const parallaxData = getParallaxData();

  const locationInput = (
    <div className={`form-group form-group-default ${addressInputFocused ? 'focused' : ''}`}>
      <input
        value=""
        readOnly
        className="form-control"
        type="text"
        onFocus={() => setAddressInputFocused(true)}
        onBlur={() => setAddressInputFocused(false)}
        placeholder={messages.desired_pickup_location}
      />
    </div>
  );

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-ecommerce-online-appointment-booking ${shownClass} ${cssClasses} ${responsiveClasses}`.trim()}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {elementStyleTag}

      <div className="clearfix">
        <Col xs={12} lg={11}>
          <h4 className={`no-margin font-secondary fs-13 text-uppercase lh-16 bold ${textClass}`}>
            {messages.desired_pickup_location}
          </h4>
          {locationInput}
        </Col>
        <Col xs={12} mdOffset={6} md={6} lgOffset={0} lg={1}>
          <h4 className="no-margin font-secondary fs-13 lh-16 hidden-xs hidden-sm hidden-md">{'\u00A0'}</h4>

          {/* Button for Desktop */}
          <Button variant="primary" className="hidden-xs hidden-sm hidden-md" block>
            <i className="fa fa-chevron-right" />
          </Button>

          {/* Button for Mobile */}
          <Button variant="primary" size="lg" className="hidden-lg text-uppercase" block>
            {messages.search}
          </Button>
        </Col>
      </div>

      {getAppendHtml()}
    </div>
  );

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementCommerceOnlineAppointmentBooking;
